export * from "./ContentMarquee";
